import { z } from "zod"
import { baseSchema, schemaToJson } from "../schema-utils.js"

export const targetTypeSchema = z.enum(["bookmark", "post", "subscription"])
export type TagTargetType = z.infer<typeof targetTypeSchema>

export const DbTagSchema = z.strictObject({
  ...baseSchema.shape,
  tag: z.string(),
  target_type: targetTypeSchema,
  target_id: z.string(),
})
export type DbTag = z.infer<typeof DbTagSchema>

export const TagSchema = schemaToJson(DbTagSchema)
export type Tag = z.infer<typeof TagSchema>
